module.exports = __webpack_public_path__ + "static/media/web-hosting.d3a23c9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/web-hosting.svg
// module id = 332
// module chunks = 0